import PropTypes from 'prop-types';
import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'
import classNames from 'classnames';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import style from './ApplyAlerts.scss';

// import Pulse from '../Pulse';
import AlertCircleIcon from '../icons/AlertCircle';
import CaretRightIcon from '../icons/CaretRight';
import ApplyAlert from '../ApplyAlert';
import Button from '../Button';
import messages from '../../locale/messages';
import {customisedIntlFormatMessage} from '../../utils/helpers';

const localMessages = defineMessages({
  applyAlertsFirstParagraphBeforeLinkText: {
    id: 'applyAlerts.FirstParagraphBeforeLinkText',
    defaultMessage:
      'Consider these suggestions for your application — they are not requirements, but they can help you make the best possible choices. ',
    description: 'First paragraph text that comes before link for the application alerts',
  },
  applyAlertsFirstParagraphTextWithLink: {
    id: 'applyAlerts.FirstParagraphTextWithLink',
    defaultMessage: 'Visit the Submitting an Application section on the {helplink} to learn more about what makes a good application.',
    description: 'Text with link to learn more about application alerts',
  },
  applyAlertsFirstParagraphTextWithLinkText: {
    id: 'applyAlerts.FirstParagraphTextWithLinkText',
    defaultMessage: 'Enrollment Support Page',
    description: 'Text for link to learn more about application alerts',
  },
  applyAlertsSecondParagraph: {
    id: 'applyAlerts.SecondParagraph',
    defaultMessage:
      'If you make any changes to your list, check for alerts again. Once you are happy with your list, you can continue.',
    description: 'Second paragraph text for the application alerts',
  },
  applyAlertsTitle: {
    id: 'applyAlerts.Title',
    defaultMessage: 'Alerts',
    description: 'Alerts box title',
  },
  applyAlertsCheckForAlerts: {
    id: 'applyAlerts.CheckForAlerts',
    defaultMessage: 'Check for alerts again',
    description: 'Check for alerts button',
  },
  applyAlertsReviewed: {
    id: 'applyAlerts.Reviewed',
    defaultMessage: `I’ve reviewed the alerts, let’s continue`,
    description: 'Reviewd link text',
  },
  applyAlertsHelp: {
    id: 'applyAlerts.Help',
    defaultMessage: `Help`,
    description: 'Help link text',
  },
});
class ApplyAlerts extends Component {
  static propTypes = {
    count: PropTypes.number.isRequired,
    alerts: PropTypes.arrayOf(PropTypes.shape).isRequired,
    onCheckForAlerts: PropTypes.func.isRequired,
    onLetsContinue: PropTypes.func.isRequired,
    intl: PropTypes.shape().isRequired,
    disableContinueWithAlerts: PropTypes.bool.isRequired,
  };

  render() {
    const { count, alerts, onCheckForAlerts, onLetsContinue, intl, disableContinueWithAlerts } = this.props;
    // sk: this is _really_ bad
    // only works if we can guarantee that the URL has a trailing slash
    const parts = window.location.pathname.split('/');
    const popped = parts.pop();
    parts.shift();
    // parts.shift();
    if (popped === '') {
      // parts.pop();
    }
    const pathName = `/${parts.join('/')}/review`;

    const outerCircle = classNames(style.alertCircle, style.alertCircleOuter);
    const innerOneCircle = classNames(style.alertCircle, style.alertCircleInnerOne);
    const innerTwoCircle = classNames(style.alertCircle, style.alertCircleInnerTwo);

    const helpLink = window.App.ENROLLMENT_SUPPORT_URL;

    return (
      /* eslint-disable jsx-a11y/no-noninteractive-tabindex */
      <div className={style.root} tabIndex="0">
        <div className={style.redBackground} />
        <div className={style.yellowBackground} />
        <div className={style.blueBackground} />
        <div className={style.content}>
          <div className={style.alertsTitle}>
            <div className={outerCircle}>
              <div className={innerOneCircle}>
                <div className={innerTwoCircle}>
                  <AlertCircleIcon size={40} fill="#4ee4b3" />
                </div>
              </div>
            </div>
            <FormattedMessage {...localMessages.applyAlertsTitle} />
            <span className={style.alertsTitleCount}>({count})</span>
          </div>
          <div className={style.contentWrapper}>
            <div className={style.columnOne}>
              <p>
                <FormattedMessage {...localMessages.applyAlertsFirstParagraphBeforeLinkText} />
                <span>&nbsp;</span>
                <FormattedMessage
                  {...localMessages.applyAlertsFirstParagraphTextWithLink}
                  values={{
                    helplink: (
                      <a
                        href={helpLink}
                        className={style.alertLink}
                        aria-label={`${customisedIntlFormatMessage(intl, localMessages.applyAlertsHelp)}, ${customisedIntlFormatMessage(intl, messages.opensInNewWindow,)}`}
                        target="_blank"
                        rel="noopener"
                      >
                        <FormattedMessage {...localMessages.applyAlertsFirstParagraphTextWithLinkText} />
                      </a>
                    ),
                  }}
                />
              </p>
              <p>
                <FormattedMessage {...localMessages.applyAlertsSecondParagraph} />
              </p>
              <div className={style.buttonWrapper}>
                <Button
                  large
                  blueFont
                  aria-label={customisedIntlFormatMessage(intl, localMessages.applyAlertsCheckForAlerts)}
                  label={customisedIntlFormatMessage(intl, localMessages.applyAlertsCheckForAlerts)}
                  onClick={onCheckForAlerts}
                />
              </div>

              <div className={style.linkWrapper}>
                <Button
                  blueFont
                  aria-label={customisedIntlFormatMessage(intl, localMessages.applyAlertsReviewed)}
                  label={customisedIntlFormatMessage(intl, localMessages.applyAlertsReviewed)}
                  onClick={onLetsContinue}
                  disabled={disableContinueWithAlerts}
                />
              </div>
            </div>
            <div className={style.columnTwo}>
              <ul className={style.columnTwoList} aria-label={customisedIntlFormatMessage(intl, localMessages.applyAlertsTitle)}>
                {alerts.map(({ description }) => (
                  <ApplyAlert key={description} description={description} />
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className={style.caret} />
      </div>
    );
  }
}

export default injectIntl(withStyles(style)(ApplyAlerts));
